<template>
  <div>
    <h2>Timeline of Maryland Forces 1754-1764</h2>
    <div class="image">
      <img
        class="image--sm"
        src="@/assets/images/us-mdcal.gif"
        alt="Calvert Arms Flag Kings Colors"
      >
      <i>
        <h5>Flag of the Dutch West Indies Company</h5>
      </i>
    </div>
    <blockquote>
      "We are assured, that his Excellency our governor has ordered two
      companies of men be raised in this province, who are to receive eight
      Pence a day, each private soldier, from the time of enlisting, and
      cloaths, arms, and accoutrements, upon their marching to join the troops
      under command under Colonel Innes; after which time they will be also
      supplied with provisions at free cost”
    </blockquote>
    <h6>Maryland Gazette, 8 August 1754</h6>
    <p>
      <b>20 August 1754</b>
      Governor Dinwiddie promises land in the Ohio country to those Virginians
      enlisting and extends the incentive to Marylanders who enter Maryland
      service.
      <br>
      <br>
      <b>September 1754</b> 50-60 men raised for CPT Dagworthy’s Company and
      marched to Ft. Mount Pleasant/Cumberland.
    </p>
    <blockquote>
      “Last Monday morning , a part of the soldiers raised in the province to go
      against the French on the Ohio marched out of town for Frederick County,
      under command of Lieutenant John Forty, and we hear the remainder will
      march the beginning of next week”
    </blockquote>
    <h6>Maryland Gazette 26 September 1754</h6>
    <p>
      <b>September 1754-October 1754</b>
      Ft Mount Pleasant (later Ft Cumberland) is built at Wills Creek
      <b>October 1757</b> COL James Innes of North Carolina is made “Camp Master
      General of Ft Cumberland. Garrison consists of Virginia, Maryland and
      North Carolina men.
    </p>
    <blockquote>
      “Last Monday a second Party of Capt. Dagworthy’s Company of soldiers
      march’d out of town, under the command of Lieutenant John Bacon, and are
      to join the others in Frederick County.”
    </blockquote>
    <h6>Maryland Gazette 3 October 1754</h6>
    <p>
      <b>November 1754</b> disposition of Maryland forces:
      <br>
      <span class="padding">CPT Dagworthy’s Company with 50 men</span>
      <br>
      <span class="padding">Cresaps “Fort” with 60 militia</span>
      <br>
      <br>
      <b>8 December 1754</b> CPT Dagworthy at Ft Cumberland with 47 men
      <br>
      <br>
      <b>18 May 1755</b> GEN Braddock at Ft. Cumberland:
    </p>
    <blockquote>
      “Each regt, Independent Compys &c in the making up of their cartridges are
      allowed 36 rounds with ball to a pound of powder and for field days and
      exercises are allowed 46 (with or without ball) to a pound of powder. Six
      women per company are allowed each of the two regts:& the Independent
      Companies, 4 women to each of the Company of Carpenters Virginian &
      Maryland Rangers, 5 women to the artillery, 2 women to the detachment of
      seamen & 2 women to the troop of light horse.”
    </blockquote>
    <br>
    <p>
      <b>June 1755</b> Braddocks Expedition
      <br>
      <span class="padding">CPT Dagworthy’s Maryland Provincial Rangers 3 Officers/49 men</span>
      <br>
      <br>
      <b>September 1755</b> CPT Dagworthy’s Company garrisons Ft Cumberland with
      30 men
    </p>
    <blockquote>
      “You are hereby directed and required to send from the militia under your
      command to Frederick Town a party of men consisting of any number more
      than twenty nine under the command of one Subaltern officer unless a
      Captain shall voluntarily offer his service and in such case you are to
      appoint one Subaltern under him……Every person should take at least one
      blanket with him and cloaths enough to serve him for a month from his
      arrival from his arrival in the frontiers together with provisions for
      himself till he shall reach Frederick Town where he will be supplied out
      of a magazine. Those who have arms & ammunition wou’d do well in taking
      both with them and those who want shall be supplied at Frederick Town.”
    </blockquote>
    <h6>
      Governor Sharpe to Militia in eight counties,
      <br>September 1755
    </h6>
    <p>
      <b>8 December 1755</b>
      CPT Dagworthy’s Company at Ft Cumberland with 47 men
    </p>
    <blockquote>
      “Sir: When I was down, the Committee among other things resolved, that the
      Maryland and Carolina Companies should not be supported with our
      Provisions. This resolve (I think) met with your approbation; upon which I
      wrote to Colonel Stephen, desiring him to acquaint Captain Dagworthy
      thereof, who paid slight regard to it, saying it was in the King's
      garison, and all the troops had an equal right to draw provisions with us,
      by his order, (as commanding officer,) and that we, after it was put
      there, had no Power to remove it without his leave. I should, therefore,
      be glad not care to act without instructions, lest it should appear to
      proceed from pique and resentment at having the command disputed. This is
      one among the numberless Inconveniences of having the Fort in Maryland.
      Captain Dagworthy, I dare venture to affirm, is encouraged to say this by
      Governor Sharpe, who we know has wrote to him to keep the command. This
      Captain Dagworthy acquainted Colonel Stephen of himself. As I have not yet
      heard how General Shirley has answered your Honor's request, I fear the
      success, especially as it is next to an impossibility (as Governor Sharpe
      has been there to plead Captain Dagworthy's cause) by writing to make the
      General acquainted with the Nature of the Dispute. The Officers have drawn
      up a memorial to be presented to the General, and, that it may be properly
      strengthened, they humbly beg your solicitation to have us (as we have
      certain advices that it is in his power) put upon the Establishment. This
      would at once put an End to Contention, which is the Root of Evil, and
      destructive to the best of Operations; and turn all our Movements into a
      free, easy Channel.”
    </blockquote>
    <h6>
      COL Washington to GOV Dinwiddie at Alexandria,
      <br>14 January, 1756
    </h6>
    <blockquote>
      "Governor Dinwiddie, at the instance of Colonel Washington, having
      referred to me concerning the right of command between him and Captain
      Dagworthy, and desiring that I should determine it, I do therefore give it
      as my opinion, that Captain Dagworthy, who now acts under a commission
      from the governor of Maryland, and where there are no regular troops
      joined, can only take rank as a provincial captain, and of course is under
      the command of all provincial field-officers; and, in case it should
      happen, that Colonel Washington and Captain Dag'worthy should join at Fort
      Cumberland, it is my order that Colonel Washington shall take the
      command.”
    </blockquote>
    <h6>GEN Shirley, at Boston 5 March 1754</h6>
    <blockquote>
      “ In a letter from Fort Cumberland, dated the fifteenth instant, there is
      advice, that two considerable bodies of French Indians have been lately
      down there, and had picked up several of the men belonging to the fort;
      but that the Commanding Officer there had detached parties immediately in
      pursuit of them, which obliged them to retreat precipitately, and thereby
      prevented their getting among the inhabitants.”
    </blockquote>
    <h6>Maryland Gazette, 11 March 1756</h6>
    <blockquote>
      “Major Prather, who has the Governors Commission to command all the forces
      on the frontier (except those at Fort Cumberland) has at this time under
      his Command about 150 men; and Captain Alexander Beall, who was out with a
      company of volunteers in November last, has orders to raise as many men as
      he can, not to exceed 200, and join Major Prather with all possible
      expedition.”
    </blockquote>
    <h6>Maryland Gazette, 11 March 1756</h6>
    <p>
      <b>22 March 1756</b> Maryland funds appropriated for construction of Ft.
      Frederick
    </p>
    <blockquote>
      “By a deposition of James Tucker, this day brought to town by an express,
      we have the following account, viz, that he was at Capt. Waggoner’s fort
      in Virginia, and heard that some of Capt. Waggoner’s Company say, that Mr.
      John Bacon, Lieutenant of Capt. Dagworthy’s Company, was kill’d and
      scalped by the Indians 4 or 5 miles from Cumberland fort; and also, that
      two men in company with Lieutenant Bacon, were wounded, but made their
      escape to the fort”
    </blockquote>
    <h6>Maryland Gazette 8 April 1756</h6>
    <p>
      <b>23 April 1756</b> Cresap’s Ambush
    </p>
    <blockquote>
      “Last Saturday there came to Baltimore –Town from Conococheague, at the
      foot of the North Mountain, forty-one persons, viz. 6 men, 5 women, and 30
      children, with some of their cattle, to avoid the fury of the enemy, and
      settle at Mr. Lawson’s works. One of the men had just removed his family
      to a hill within sight of his house, when Indians came and burnt his
      houses, destroy’d his plantation and kill’d his cattle. He says that
      Thomas and Danile Cresap (sons of Col. Cresap) went out about three weeks
      since, with sixty people , dressed and painted like Indians, to kill the
      women and children in the Indian towns, and scalp them, while their
      warriors are committing like destruction on our frontier”
    </blockquote>
    <h6>Maryland Gazette, 29 April 1756</h6>
    <blockquote>
      “We mentioned in our last that Mr. Thomas Cresap, junr., and his brother
      with a party of men painted and dress’d like Indians, were gone out in
      pursuit of the enemy: since which we are now informed by Capt. Dagworthy
      (who came to town yesterday from Fort Cumberland), that on the 23d of
      April, as Mr. Cresap and his party lay in ambush near the Little-Meadows,
      they saw a party of Indians coming by them; but one of the party firing
      too soon, alarm’d them, and they fled as fast as possible into thickets,
      leaving their horses and baggage, which out people took and brought off
      with them; among their baggage one scalp was found. One of the Indians
      taking a different course from the rest; Mr. Cresap, and two others after
      him near a mile, when the Indians finding that Mr. Cresap gain’d on him
      and would overtake him, he dodged behind a large tree and Mr. Cresap
      stopp’d behind one smaller; and they fired at one another so near together
      that it could not be distinguish’d which fired first. Mr. Cresap was shot
      with large shot in the breast, and the others of his party coming up, he
      told them, not to mind him, he was a dead man, but to pursue the enemy;
      and then dropped down dead. The Indian was shot thro’ the right breast ,
      but was not dead when they came up to him, and so they dispatch’d him with
      a tomahawk and scalp’d him. Mr. Cresap’s body they buried as privately as
      they could. He was a young widower, and has left two little children and
      his death is lamented by all who knew him.”
    </blockquote>
    <h6>Maryland Gazette, 6 May 1756</h6>
    <p>
      <b>May 1756</b> Two Companies raised to serve until Feb 1757:
      <br>

      <span class="padding">CPT Dagworthy’s (100 men)</span>
      <br>
      <span class="padding">CPT Alexander Beall’s (100 men)</span>
    </p>
    <blockquote>
      “G.R. Our will and pleasure is, that you attend the Proclamation of our
      Declaration of War against France, that is to be made tomorrow, being
      Tuesday the eighteenth instant, between the hours of nine and twelve, in
      the morning, in the usual places, and with the solemnities customary on
      the like occasion; and for so doing, this shall be your Warrant."
    </blockquote>
    <h6>
      Given at our Court at Kensington, the 17th of May 1756,
      <br>in the 29th year of Our Reign by His Majesties Command, H. FOX
    </h6>
    <p>
      <b>20 May 1756</b>
      COL Thomas Cresap’s “red caps’ (100 men) ambush French/Indian raiding
      party.
      <b>30 Jun 1756</b> COL Thomas Cresap’s “red caps’ (100 men) ambush
      French/Indian raiding party.
    </p>
    <blockquote>
      “We hear from the mouth of the Conococheague, that four Indians, dressed
      in red caps and much like Col. Cresap’s men, came down among the
      inhabitants there, and killed and scalped two people, and then made off. A
      party of 46 men were immediately sent out after them; but they have not
      yet been able to meet with them.”
    </blockquote>
    <h6>29 July 1756 Maryland Gazette</h6>
    <p>
      <b>2 August 1756</b>
      Ft Frederick Garrison:
      <br>
      <span class="padding">CPT Dagworthy’s Company (100 men)</span>
      <br>
      <span class="padding">CPT Alexander Beall’s Company (100 men)</span>
    </p>
    <blockquote>
      “Deserted from the Maryland Forces at Fort-Frederick, William Withers,
      alias, Delaney, and John Hopkins. Withers, an Irishman, aged about 34
      years, a straight fellow, bout 5 feet 11 inches high, has dark brown hair,
      full grey eyes, much marked on the face by small pox, and speaks plain
      English; had on when he went away, an old blue coat, an old felt hat, a
      coarse white linen shirt, and strong shoes not much worn; he carried off
      with him a gun that appeared on the outside of the barrel like a rifle but
      was smooth bored. John Hawkins, an Englishman, aged about 29 years, a well
      set fellow, about 5 feet 6 inches high, has black hair, and a fresh
      complexion: he lived some time as a servant with the widow Swaford betwixt
      the North and South Mountain, in Frederick County Maryland. He had on when
      he went away, an old felt hat, a white coarse cloth coat, dirty leather
      breeches, coarse white worsted stockings, and strong shoes not much worn;
      he carried off with him a carbine and rifle. Whoever apprehends either of
      the said deserters will be entitled to twenty Shillings reward; and any
      person who may conceal or entertain them, or purchase their arms, will be
      punished as the Law directs. John Dagworthy.”
    </blockquote>
    <h6>5 August 1756 Maryland Gazette</h6>
    <blockquote>
      “The views of the enemy are designed against the lower inhabitants. They
      have laid Maryland and Pennsylvania waste, as low as Carlisle, the
      inhabitants of which place we are told are flying with the utmost
      consternation. They have made an attempt on the Virginia side, killed one
      and captivated another on the Conogochieg road, four miles hitherwards,
      but retreated back, for how long a time.”
    </blockquote>
    <h6>
      COL Washington to LTC Adam Stephen at Winchester,
      <br>5 August, 1756
    </h6>
    <p>
      <b>30 August 1756</b> 2 militia companies sent to Ft Frederick for 1 month
    </p>
    <blockquote>
      "The frontiers of Maryland are abandoned for many miles below the Blue
      Ridge, as low as Frederick-Town, thro' which place I am credibly informed
      no less than 350 wagons, transporting the affrighted families, passed in
      the space of three days. By which means, Potomack River, which is now our
      frontier, is deserted on the Maryland side 40 miles below Conocgch. and as
      much in a parellel below Winchester, and is now more than any the theater
      of bloodshed and cruelty."
    </blockquote>
    <h6>
      COL Washington to GOV Dinwiddie, at Winchester,
      <br>8 September, 1756
    </h6>
    <p>
      <b>October 1756</b> 3rd company of 100 men added to serve to Apr 1757
      <br>
      <br>
      <b>February 1757</b> 2 companies extended to Apr 1757
      <br>
      <br>Deserted from Fort Frederick, on the 22nd of February, in the
      evening, the two following persons, viz., Phillip Connelly, aged 28 years,
      5 feet 10 inches high, of a brown complexion, and was born in St Mary’s
      County, Maryland. He had on when he went away, a red coat and breeches
      (the sleeves of his coat turn’d up with black) and white metal buttons, a
      new felt hat, and a new white shirt, and is supposed to have carried
      another with him. Aaron Halsworth, aged 20 years, 5 feet 3 inches and ½
      high, of a brown complexion, a Cutler by trade, was born in England, and
      served his time at Mr. Snowden’s iron works: his dress is the same with
      Connelly’s. They have carried their arms with them. Whoever will take up
      the said deserters, and bring them to Fort Frederick, or secure them so
      that they may be brought to the fort shall have a pistole reward for each
      man paid by Joshua Beall.
      <br>
      <br>
      <b>10 March 1757</b>, Maryland Gazette
      <br>
      <br>
      <b>April 1757</b> CPT Alexander Beal’s Company garrison Ft Frederick.
      <br>
      <br>
      <b>1 May 1757</b> Virginia Regiment departs Ft Cumberland and turns it
      over to Maryland Forces
      <br>
      <br>
      <b>May 1757</b> Maryland Forces, commanded by CPT Dagworthy, composed of
      the following:
      <br>
      <span class="padding">CPT John Dagworthy</span>
      <br>
      <span class="padding">CPT Alexander Beall</span>
      <br>
      <span class="padding">CPT Joshua Beall</span>
      <br>
      <span class="padding">CPT Francis Ware</span>
      <br>
      <span class="padding">CPT Richard Pearis (Cherokee and Catawba Indians)</span>
    </p>
    <blockquote>
      "Annapolis May 19. By an Act of Assembly of this province, which was made
      in October last, and still is in full force, any inhabitant of this
      Province, or any Indian in our alliance, that shall kill an enemy Indian,
      either within or out of the Province, is entitled to the sum of fifty
      pounds on producing the scalp of such enemy Indian to a magistrate: and
      any inhabitant of either of the neighboring Colonies, is, on his producing
      such Indian’s scalp, and satisfy a Magistrate that he was really killed
      within this Province entitled to the same reward.”
    </blockquote>
    <h6>Maryland Gazette, 19 May 1757</h6>
    <blockquote>
      "May 17, 1757 Deserted from a recruiting party of the Maryland Forces,
      under the command of Robert Hanson, at Port-Tobacco, in Charles County,
      Oswald Addams, but enlisted by the name of William Addams; he is about 5
      feet 81/2 inches high, of a fair complexion, about 32 years of age and
      thin visaged. Had on a dark cloth coat trimm’d with brass buttons, a
      country cloth waistcoat, brown Holland breeches, and a brown cut wig.
      Whoever apprehends the said deserter, and confines him in any Gaol, shall
      have forty shillings reward; or if brought to Port-Tobacco, two pistols
      paid by Robert Hanson.”
    </blockquote>
    <h6>Maryland Gazette, 2 June 1757</h6>
    <blockquote>
      "Upper Marlborough, June 9, 1757. Deserted from a Recruiting Party of the
      Maryland Forces, commanded by Lieutenant Duncan MacRae, Joseph Mchugh, who
      was born in the lower part of Prince-George’s County, near Patuxent; he is
      about 25 years of age, 5 feet, 9 inches high of a dark complexion, has
      black eyes, and his hair was black, but was very lately cut off. Whoever
      will apprehend and have the said deserter secured in any Gaol within this
      Province, or delivered to any Officer of the aforesaid Forces, shall have
      two pistols reward, paid by Captain Pearis, or Lieutenant MacRae.”
    </blockquote>
    <h6>Maryland Gazette, 23 June 1757</h6>
    <blockquote>
      "Deserted from Francis Ware’s Company, the 14th of this instant June, on
      his march to Fort-Frederick, Patrick Grame, a Scotchman, aged 25 years, 5
      feet 4 ½ inches high, of a brown complexion, has dark eyes, and black
      hair, middling long, has a down look, and is mark’d with the small-pox;
      had on when he went away, a jacket made of a Dutch blanket, grey
      country-made stockings, and shoes about half worn. Whoever takes up the
      said deserter, and delivers him to any of the Recruiting-Officers in this
      Province, or contrives him to Fort-Frederick, shall have two pistoles
      reward paid by Francis Ware "
    </blockquote>
    <h6>Maryland Gazette, 23 June 1757</h6>
    <blockquote>
      “In the letter which I addressed to you on the 26th of May I informed you
      that the Assembly of this Province had in compliance with the Earl of
      Loudoun’s requisition agreed to support five hundred men for the immediate
      defense of the Province and to act on any emergency in conjunction with
      such other forces as should be employed in these parts to annoy His
      Majesty’s enemies. Some of these men were by his Lordship’s Order marched
      to garrison Fort Cumberland while the rest were left at Fort Frederick to
      patrol on our frontiers at a small distance beyond the settlements, and by
      this disposition of them the inhabitants have been so effectually secured
      this summer from incursions of the enemy that we have not lost a single
      person, exclusive of soldiers and such as attend them. The money which had
      been appropriated for the support of these troops being now expended , I
      have convened the Assembly again and recommended it to them to grant
      further supplies for their support, but I am sorry to inform you that they
      have absolutely refused to provide for any men that rare or may be ordered
      to Fort Cumberland , and that they are also resolved to reduce the troops
      in the pay of this Province to three hundred, who shall they say on no
      account whatever be employed otherwise that in garrisoning Fort Frederick
      and patrolling just beyond our frontier settlements.”
    </blockquote>
    <h6>
      GOV Sharpe to Prime Minister Pitt,
      <br>22 October 1757
    </h6>
    <p>
      <b>October 1757</b>
      Reduction to 3 companies assigned to garrison Ft. Frederick and patrolling
      the border
      <br>
      <br>
      <b>December 1757</b> CPT Alexander Beall’s Company (100 men) garrison at
      Ft Frederick and other companies (360 men) at Ft Cumberland or on ranging
      duty.
    </p>
    <blockquote>
      “They not only insisted on our troops being withdrawn from Fort
      Cumberland, but likewise that they should be forthwith reduced from 500 to
      300 men & that none of such 300 should be subject on any account whatever
      to the Commands of the Earl of Loudoun or any other of His Majesty’s
      Generals"
    </blockquote>
    <h6>
      GOV Sharpe to Prime Minister Pitt on the Colonial Assembly,
      <br>16 March 1758.
    </h6>
    <blockquote>
      “The men that are in garrison at Fort Cumberland, being in number about
      300, have continued to serve without pay since the 8th of October as well
      as those that are at Fort Frederick, but as it could not be expected that
      their Officers would be able to keep them together much longer I wrote to
      the Commander in Chief as well as COL Stanwix & desired that some other
      troops might be ordered to Fort Cumberland which I presume will be done as
      soon as the roads become practicable.”
    </blockquote>
    <h6>
      GOV Sharpe to Prime Minister Pitt,
      <br>16 March 1758
    </h6>
    <blockquote>
      “Rather than let your troops be disbanded, I will take them into the pay
      of the Crown, upon the footing of Rangers.”
    </blockquote>
    <h6>
      GEN Forbes to GOV Sharpe,
      <br>2 May 1758
    </h6>
    <blockquote>
      “I must likewise desire that you will order all your troops up to Fort
      Cumberland and make Colonel Washington’s people take up their post at Fort
      Frederick.”
    </blockquote>
    <h6>
      GEN Forbes to GOV Sharpe,
      <br>12 May 1758
    </h6>
    <blockquote>
      “As soon as those of them that that are at Fort Frederick and on our
      frontiers receive orders to march westward which I expect they will in
      about three weeks, I shall proceed to that Fort with two companies of
      militia & use my best endeavors to protect our frontier inhabitants with
      them during the continuance of the expedition.”
    </blockquote>
    <h6>
      GOV Sharpe to Prime Minister Pitt,
      <br>18 May 1758
    </h6>
    <p>
      <b>31 May 1758</b> CPT Pearis’ Company disbanded
      <br>
      <br>
      <b>9 June 1758</b> CPT Dagworthy and 150 men sent from Ft Frederick to
      garrison Ft. Cumberland. CPT Alexander Beall’s Company and volunteer
      militia garrison Ft Frederick
    </p>
    <blockquote>
      “As they are only 300 men, and have been used to the woods and the Indian
      manner of fighting, I thought it would be a great loss to allow them to
      disband themselves, upon the province refusing then their by past pay, or
      continuing the during the Campaign; so have therefore made them an offer
      to pay them from this time during the rest of the Campaign, and to solicit
      for their past pay.”
    </blockquote>
    <h6>
      GEN Forbes to William Pitt,
      <br>17 June, 1758
    </h6>
    <blockquote>
      Sir, Having considered what you told me concerning the situation of your
      Maryland Troops, and particularly about the distressed condition of the
      Officers and of Mr. Ross by whom to your forces have been victualled since
      the money which was granted by your assembly for their support was
      expended, and being very adverse to your troops being disbanded at this
      critical juncture when in all probability I shall have great occasion for
      their service, I am induced to advance a sum of money towards relieving
      those Gentlemen in some measure from the difficulties wherein they are
      involved by the late extraordinary conduct of your Assembly, and to
      encourage your Troops to keep together during the Campaign."
    </blockquote>
    <h6>
      General Forbes to Governor Sharpe,
      <br>20 July 1758
    </h6>
    <p>
      <b>August 26–17 Sep 1758</b> Maryland forces rendezvous at Ft. Bedford for
      Forbes Expedition
      <br>
      <span class="padding">LTC Dagworthy’s Company</span>
      <span class="padding">CPT Alexander Beall’s Company</span>
      <br>
      <span class="padding">CPT Joshua Beall’s Company</span>
      <br>
      <span class="padding">CPT Francis Ware’s Company</span>
      <br>
      <span class="padding">(16 Officers/270 men)</span>
    </p>
    <blockquote>
      “I have told the General that I am afraid no more of the militia would be
      prevailed on to come thus far if I was to attempt to carry ‘em to Fort
      Cumberland, bit I am endeavoring to get 200 or 250 Volunteers to accompany
      me to Fort Cumberland & to stay there till the affair is decided.
      <br>Beside the Maryland Troops as we call them which consist of 320 men
      I have prevailed on a Company of 40 Volunteers all good marksmen & used to
      the woods to join the army, they are commanded by a Gentleman that has
      served upward of two years as a Lieutenant in our provincials.”
    </blockquote>
    <h6>
      GOV Sharpe to Prime Minister Pitt,
      <br>27 August 1758
    </h6>
    <blockquote>
      “I have wrote to Colo Bouquet of your kind agreement of garrisoning Fort
      Cumberland for the first month of my absence, and that 250 of your men
      would be there by the 10th or 12th instant, ordering the Commissary to
      furnish them with provisions and a gill of spirits each day during their
      stay in that service.”
    </blockquote>
    <h6>
      GEN Forbes to GOV Sharpe,
      <br>3 September 1758
    </h6>
    <blockquote>
      ‘The Governor of Maryland I am greatly obliged to, having personally acted
      with the greatest zeal for the Service, first by sending 50 volunteers all
      good woods men to join me, and now by marching 200 of his militia (I
      believe contrary to his Assembly’s inclination) to garrison Fort
      Cumberland for one month or until the 12th of October.”
    </blockquote>
    <h6>
      GEN Forbes to William Pitt,
      <br>6 September 1758
    </h6>
    <p>
      <b>14 September 1758</b> Grants Raid
      <br>

      <span class="padding">CPT Ware’s Company (95 men)</span>
      <br>
      <span class="padding">KIA LT Moore and 23 men</span>
      <br>
      <br>
      <b>14 October 1758 Ligonier defense</b>
      <br>
      <span class="padding">CPT Evan Shelby’s Company of Maryland Volunteers (50 men)</span>
      <br>
      <span class="padding">2 KIA, 6 WIA and 12 missing</span>
    </p>
    <blockquote>
      “The 60 Maryland volunteers went out and attacked them with vigor and
      courage”
    </blockquote>
    <h6>
      General Forbes to Richard Peters,
      <br>16 October 1758
    </h6>
    <p>
      <b>12 November 1758</b> Ligonier skirmish
      <br>
      <br>

      <b>15-24 November 1758</b> move to Duquesne
    </p>
    <blockquote>
      “Sir, I have the pleasure and honour of acquainting you with the signal
      success of His Majesty’s Troops over all his enemies on the Ohio, by
      having obliged them to burn and abandon their fort Du Quesne which they
      effectuated upon the 24th instant.”
    </blockquote>
    <h6>
      General Forbes to Governor Denny,
      <br>26 November 1758
    </h6>
    <p>
      <b>December 1758-April 1759</b> 2 Companies garrison Ft Frederick
      <br>
      <br>

      <b>30 December 1758</b> CPT Alexander Beall’s Company disbanded
      <br>

      <span class="padding">CPT Joshua Beall’s Company disbanded</span>
      <br>
      <span class="padding">CPT Francis Ware’s Company disbanded</span>
      <br>
      <br>
      <b>July 1763</b> Bouquet’s Expedition to relieve Ft. Pitt
      <br>
      <span class="padding">CPT Lemuel Barret’s Maryland ranger detachment (30 men)</span>
      <br>
      <br>

      <b>5 August 1763</b> Battle of Bushy Run
      <br>
      <span class="padding">CPT Lemuel Barret’s Maryland ranger detachment (30 men)</span>
      <br>
      <br>

      <b>August-November 1764</b>
      Bouquets Expedition to the Ohio
      <br>
      <span class="padding">CPT McClellan’s Company (43 men)</span>
      <br>
      <span class="padding">CPT Wolgamott’s Company (15 men)</span>
    </p>
    <hr>
    <h3>Sources:</h3>
    <ol>
      <li>
        Browne, William Hand, “Proceeds of the Council of Maryland, August 10,
        1753-March 20, 1761, Letters to Governor Horatio Sharpe, 1754-1765”,
        Maryland Historical Society, Baltimore, 1911
      </li>
      <li>
        Busch, Clarence M., “Report of the Commission to Locate the Site of the
        Frontier Forts of Pennsylvania,” Vol. 1, State Printer of Pennsylvania,
        1896,
      </li>
      <li>
        Dixon, David, “Never Come to Peace Again”, University of Oklahoma Press,
        Norman, OK, 2005
      </li>
      <li>
        Edgar, Lady, “A Colonial Governor in Maryland, Horatio Sharpe and His
        Times 1753-1773,” Longman Green and Co., London, 1912
      </li>
      <li>
        Hamilton, Stanislaus, ed., “Letters to Washington, Vol. II, 1756-1758”,
        Houghton, Mifflin and Co., Cambridge, 1899
      </li>
      <li>
        Kimball, Gertrude, ed., “Correspondence of William Pitt, Vol. I.,
        MacMillan Company, New York, 1906
      </li>
      <li>
        Mc Ilwaine, H.R., ed., “Journals of the House of Burgesses of Virginia,
        1758-1761,” Richmond, VA, 1908
      </li>
      <li>
        Mc Sherry, James, “History of Maryland”, Baltimore Book Club, Baltimore,
        1904
      </li>
      <li>
        Sparks, Jared, ed., “Writings of George Washington, Vol. II,” Little
        Brown, and Co., Boston 1855
      </li>
      <li>
        Stewart, Irene, ed. “Letters of General John Forbes relating to the
        Expedition against Fort Duquesne in 1758,” Colonial Dames of America
      </li>
      <li>
        The Pennsylvania-German Society, Proceedings and Addresses at
        Harrisburg, PA., October 20. 1911, Vol. XXII, 1913
      </li>
      <li>
        The Official Records of Robert Dinwiddie, Vol.’s I and II, Virginia
        Historical Society Richmond, VA, 1884
      </li>
      <li>
        <a
          href="http://www.msa.md.gov/megafile/msa/speccol/sc4800/sc4872/001279/html/index.html"
        >Maryland Gazette ( MSA SC 2731) January 2, 1752 - October 19, 1758</a>
      </li>
    </ol>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
